<template>
  <div id="support-footer">
    <a href="https://ee.kobotoolbox.org/x/#u1b3UVSL" target="_blank">
      <div class="report-button">
        <div class="icon-report"></div>
        {{$t('kit.reportingTool')}}
      </div>
    </a>
  </div>
</template>

<script>
  export default {
      name: "support-footbar"
  }
</script>

<style lang="stylus" scoped>
#support-footer
  display: flex;
  width: 100%;
  box-shadow: 0pt 3pt 18pt rgba(0,0,0, 0.16);
  background: #ffffff;
  height: 60px
  align-items center
  justify-content center
  a
    color #707070
    text-decoration none 
    width 80%
    :visited
      color #707070
    .report-button
      border 1px solid #72E3C3
      border-radius 9px
      padding 7px 15px
      min-height 25px
      color #707070
      cursor pointer
      display flex
      align-items center
      justify-content center
      .icon-report
          background: url('~@/../static/icons/reporting-green.svg') no-repeat center center;
          width 25px
          height 25px
          margin-right 10px

</style>



// WEBPACK FOOTER //
// src/components/SupportFootbar.vue